module.exports = __webpack_public_path__ + "sh.5ab3ccf4f62805cd4b01.svg";


//////////////////
// WEBPACK FOOTER
// D:/projects/feelway-pawnshop/pawnshop-web-client-feelway/src/assets/scss/icons/flag-icon-css/flags/sh.svg
// module id = ../../../../../src/assets/scss/icons/flag-icon-css/flags/sh.svg
// module chunks = styles